@if (canShowChat()) {
<div class="chat-host" [class.chat-host-open]="isOpen()">
  @if (isOpen()) {
    <section class="chat-panel" aria-label="Navigator AI Assistant">
      <header class="chat-panel-header">
        <div class="chat-title">
          <span class="chat-title-icon"><i class="ri-chat-3-line"></i></span>
          <div>
            <h2>Navigator AI Assistant</h2>
            <p>{{ selectedProductLine() }}</p>
          </div>
        </div>
        <button type="button" class="chat-icon-btn" title="Close chat" (click)="closePanel()">
          <i class="ri-close-line"></i>
        </button>
      </header>

      <div class="chat-toolbar">
        <label class="chat-field">
          <span>Product line</span>
          <select [ngModel]="selectedProductLine()" (ngModelChange)="setProductLine($event)" [disabled]="loading()">
            @for (productLine of productLines(); track trackProductLine($index, productLine)) {
              <option [value]="productLine">{{ productLine }}</option>
            }
          </select>
        </label>
        <button type="button" class="chat-secondary-btn" (click)="startNewChat()" [disabled]="loading()">
          <i class="ri-add-line"></i>
          New
        </button>
      </div>

      @if (sessions().length > 0) {
        <div class="chat-session-strip" aria-label="Recent chat sessions">
          @for (session of sessions(); track trackSession($index, session)) {
            <button
              type="button"
              class="chat-session-chip"
              [class.active]="session.session_id === activeSessionId()"
              (click)="loadSession(session.session_id)"
              [disabled]="loading() || loadingHistory()">
              {{ session.last_message_preview || 'Recent chat' }}
            </button>
          }
        </div>
      }

      <div #messagesViewport class="chat-messages">
        @if (messages().length === 0 && !loadingHistory()) {
          <div class="chat-empty">
            <i class="ri-sparkling-2-line"></i>
            <p>Ask a technical question about {{ selectedProductLine() }} documents.</p>
          </div>
        }

        @if (loadingHistory()) {
          <div class="chat-loading-row">
            <span class="chat-spinner"></span>
            Loading session...
          </div>
        }

        @for (message of messages(); track trackMessage($index, message)) {
          <article class="chat-message" [class.user]="message.role === 'user'" [class.assistant]="message.role === 'assistant'">
            <div class="chat-message-bubble">
              <div class="chat-message-text">{{ message.text }}</div>

              @if (message.citations?.length) {
                <div class="chat-citations">
                  <span class="chat-citations-label">Citations</span>
                  @for (citation of message.citations; track trackCitation($index, citation)) {
                    <button type="button" class="chat-citation" (click)="openCitation(citation)">
                      <i class="ri-file-text-line"></i>
                      <span>{{ citation.document || 'Source' }}</span>
                      @if (citation.page || citation.page_range) {
                        <small>p. {{ citation.page_range || citation.page }}</small>
                      }
                    </button>
                  }
                </div>
              }

              @if (message.role === 'assistant' && message.chatMessageId) {
                <div class="chat-feedback">
                  <button
                    type="button"
                    class="chat-feedback-btn"
                    [class.selected]="message.feedback === 'positive'"
                    title="Helpful"
                    (click)="submitFeedback(message, 'positive')">
                    <i class="ri-thumb-up-line"></i>
                  </button>
                  <button
                    type="button"
                    class="chat-feedback-btn"
                    [class.selected]="message.feedback === 'negative'"
                    title="Not helpful"
                    (click)="submitFeedback(message, 'negative')">
                    <i class="ri-thumb-down-line"></i>
                  </button>
                </div>
              }
            </div>
          </article>
        }

        @if (loading()) {
          <div class="chat-loading-row">
            <span class="chat-spinner"></span>
            Searching documents...
          </div>
        }
      </div>

      @if (errorMessage()) {
        <div class="chat-alert error">{{ errorMessage() }}</div>
      }
      @if (feedbackMessage()) {
        <div class="chat-alert success">{{ feedbackMessage() }}</div>
      }

      <footer class="chat-composer">
        <textarea
          #messageInput
          [(ngModel)]="draftMessage"
          rows="2"
          placeholder="Ask about troubleshooting, configuration, parts, or procedures..."
          (keydown)="onComposerKeydown($event)"
          [disabled]="loading() || loadingHistory()">
        </textarea>
        <button
          type="button"
          class="chat-send-btn"
          title="Send"
          (click)="sendMessage()"
          [disabled]="loading() || loadingHistory() || !draftMessage.trim()">
          <i class="ri-send-plane-2-line"></i>
        </button>
      </footer>
    </section>
  }

  <button
    type="button"
    class="chat-bubble-btn"
    [class.active]="isOpen()"
    title="Open chat"
    aria-label="Open chat"
    (click)="toggleOpen()">
    <i class="ri-chat-3-line"></i>
  </button>
</div>
}
